export const TOKEN_STORAGE_KEY = "token";
export const USER_STORAGE_KEY = "user";

export function getStoredToken() {
  return localStorage.getItem(TOKEN_STORAGE_KEY);
}

export function clearStoredAuth() {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(USER_STORAGE_KEY);
}

export function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp <= currentTime;
  } catch (_error) {
    return true;
  }
}

export function getValidToken() {
  const token = getStoredToken();

  if (!token) {
    return null;
  }

  if (isTokenExpired(token)) {
    clearStoredAuth();
    return null;
  }

  return token;
}
